import React, { Component } from 'react';
import './PolicySearchModal.css';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm, change, getFormValues, formValueSelector, reset } from 'redux-form';
import InputField from "../Input-field/InputField";
import VinCodeInput from '../VinCodeInput/VinCodeInput';
import FaClose from "react-icons/lib/fa/close";
import InputRadio from "../Input-radio/InputRadio";
import { connect } from 'react-redux';
import { openPolicySearchModal, searchPolicyResult } from "../../actions/policies";
import api from "../../api/index";
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

function submit(values) { }


const validate = values => {
    const errors = {};
    // if(!values.policyId){
    //     errors.policyId = "fillInput"
    // }

    if (values.policyId && (/[^a-z0-9]/i.test(values.policyId))) {
        errors.policyId = "inputInEnglish"
    }

    if (values.policyId && values.policyId.length > 10) {
        errors.policyId = 'max10Symbols';
    }

    // if(!values.vinCode){
    //     errors.vinCode = "fillInput"
    // }

    // if (values.vinCode && values.vinCode !== values.vinCode.toUpperCase()){
    //     errors.vinCode = 'InputOnlyUppercase';
    // } 

    if (values.vinCode && (/[^a-z0-9]/i.test(values.vinCode))) {
        errors.vinCode = "inputInEnglish"
    }

    if (values.vinCode && values.vinCode.length > 20) {
        errors.vinCode = 'max20Symbols';
    }

    // if(!values.chassisNumber){
    //     errors.chassisNumber = "fillInput"
    // }

    // if (values.chassisNumber && values.chassisNumber !== values.chassisNumber.toUpperCase()){
    //     errors.chassisNumber = 'InputOnlyUppercase';
    // } 

    if (values.chassisNumber && (/[^a-z0-9]/i.test(values.chassisNumber))) {
        errors.chassisNumber = "inputInEnglish"
    }

    if (values.chassisNumber && values.chassisNumber.length > 20) {
        errors.chassisNumber = 'max20Symbols';
    }

    // if(!values.vehicleRegistrationNumber){
    //     errors.vehicleRegistrationNumber = "fillInput"
    // }
    if ((values.vinCode || values.chassisNumber || values.policyId) && !values.vehicleRegistrationNumber) {
        errors.vehicleRegistrationNumber = "fillRegistrationNumber"
    }

    if (values.vehicleRegistrationNumber && (!values.vinCode && !values.chassisNumber && !values.policyId)) {
        errors.vehicleRegistrationNumber = "insertOneMoreField"
    }

    // if (values.vehicleRegistrationNumber && values.vehicleRegistrationNumber !== values.vehicleRegistrationNumber.toUpperCase()){
    //     errors.vehicleRegistrationNumber = 'InputOnlyUppercase';
    // } 

    if (values.vehicleRegistrationNumber && (/[^a-z0-9]/i.test(values.vehicleRegistrationNumber))) {
        errors.vehicleRegistrationNumber = "inputInEnglish"
    }

    if (values.vehicleRegistrationNumber && values.vehicleRegistrationNumber.length > 20) {
        errors.vehicleRegistrationNumber = 'max20Symbols';
    }

    if (!values.vehicleRegistrationNumber && !values.vinCode && !values.chassisNumber && !values.policyId) {
        errors.vehicleRegistrationNumber = "insertFields"
    }


    return errors
}

class PolicySearchModal extends Component {
    constructor() {
        super()
        this.state = {
            result: false,
            searchStatus: ''
        }
    }

    onSearchPolicy = () => {
        this.props.dispatch(reset('SearchPolicyFormResult'));
        let value = this.props.SearchPolicyFormFields
        if (value) {
            this.setState({
                searchStatus: 'Data',
                result: true
            })
            if ((value.vinCode && value.vehicleRegistrationNumber) || (value.chassisNumber && value.vehicleRegistrationNumber) ||
                (value.policyId && value.vehicleRegistrationNumber)) {
                let ob = {
                    vinCode: value.vinCode ? value.vinCode.toUpperCase() : '',
                    chassisNumber: value.chassisNumber ? value.chassisNumber.toUpperCase() : '',
                    registrationNumber: value.vehicleRegistrationNumber ? value.vehicleRegistrationNumber.toUpperCase() : '',
                    policyNumber: value.policyId ? value.policyId.toUpperCase() : ''
                }
                api.policy.findPolicy(ob).then(({ data }) => {
                    if (data.length) {
                        this.setState({
                            result: false,
                        })
                        this.props.dispatch(searchPolicyResult([]));
                        this.props.dispatch(searchPolicyResult(data));
                        this.props.history.push(`/${this.props.currentLocale.code}/searchResult?pi=` + ob.policyNumber + `&vin=` + ob.vinCode + `&cN=` + ob.chassisNumber + `&vrn=` + ob.registrationNumber);
                        this.props.dispatch(openPolicySearchModal(false));
                        this.props.dispatch(reset('SearchPolicyForm'));
                        this.updateData(value)
                    }
                    else {

                        this.setState({
                            searchStatus: 'NoData'
                        })
                    }
                })
            }
        }
    }

    updateData = (value) => {
        this.props.dispatch(change('SearchPolicyFormResult', 'policyId', value.policyId));
        this.props.dispatch(change('SearchPolicyFormResult', 'vinCode', value.vinCode));
        this.props.dispatch(change('SearchPolicyFormResult', 'chassisNumber', value.chassisNumber));
        this.props.dispatch(change('SearchPolicyFormResult', 'vehicleRegistrationNumber', value.vehicleRegistrationNumber));
    }
    render() {
        const customStyles = {
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                width: '410px',
                background: '#ffffff',
                padding: '0',
                borderRadius: '15px'
            },
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                zIndex: '11222'
            }
        };
        const { handleSubmit, pristine, reset, submitting, translate, vehicleRegistrationNumber, vinCode, policyId, chassisNumber } = this.props
        return (
            <Modal
                isOpen={this.props.openSearchModal}
                closeTimeoutMS={150}
                style={customStyles}
                contentLabel="Modal"
                ariaHideApp={false}
            >
                <div>
                    <form onSubmit={handleSubmit} onChange={() => { this.setState({ result: false }) }}>
                        <div className="policy-search-header">
                            <h3 className="policy-search-header-text">{translate('policySearch')}</h3>
                            <FaClose onClick={() => {
                                this.props.dispatch(reset('SearchPolicyForm')),
                                    this.props.dispatch(openPolicySearchModal(false), this.setState({ result: false }))
                            }} className="policy-search-modal-close" />
                        </div>
                        <div className="policy-search-body">
                            <Field name="policyId" labelName={"policyId"} uppercase={true} component={InputField} id={11112} placeholder={""} type="text" />
                            <Field name="vinCode" labelName={"vinCodeorchassisNumber"} uppercase={true} component={VinCodeInput} id={11114} placeholder={""} type="text" />
                            {/* <Field name="chassisNumber" labelName={"chassisNumber"} uppercase={true} component={InputField} id={11113} placeholder={""} type="text" /> */}
                            <Field name="vehicleRegistrationNumber" labelName={"vehicleRegistrationNumber"} uppercase={true} component={InputField} id={11115} placeholder={""} type="text" />
                        </div>

                        {this.state.result && this.state.searchStatus === 'NoData' && (<div className="no-result">{translate('noFiendPolicy')}</div>)}
                        {/* {this.state.result && !vinCode && !policyId && !chassisNumber && vehicleRegistrationNumber && (<div className="no-result">{translate('fillMoreField')}</div>)}
                              {this.state.result && vinCode && !vehicleRegistrationNumber && (<div className="no-result">{translate('fillMoreField')}</div>)} */}

                        {/* {this.state.result && this.state.searchStatus === 'NoData' && (<div className="no-result">{translate('noFiendPolicy')}</div>)}
                              {this.state.result && policyId && (/[^a-z0-9]/i.test(policyId))}
                              {this.state.result && (policyId || vinCode || chassisNumber) && !vehicleRegistrationNumber && (<div className="no-result">{translate('fillRegistrationNumber')} </div>)} 
                              {this.state.result && vehicleRegistrationNumber && !policyId && !vinCode && !chassisNumber && (<div className="no-result">{translate('fillMoreField')} </div>)} 
                              {this.state.result && policyId} */}
                        {/* {touched &&(error && <span className="error-text">{translate(error)}</span>)} */}

                        <button className="policy-search-btn" onClick={this.onSearchPolicy}>{translate('search')}</button>
                    </form>
                </div>
            </Modal>
        )
    }
}
PolicySearchModal = reduxForm({
    validate,
    onSubmit: submit,
    destroyOnUnmount: false,
    form: 'SearchPolicyForm', // a unique identifier for this form
})(PolicySearchModal);
const selector = formValueSelector('SearchPolicyForm');

const mapStateToProps = (state, store) => {
    const vehicleRegistrationNumber = selector(state, 'vehicleRegistrationNumber')
    const vinCode = selector(state, 'vinCode')
    const policyId = selector(state, 'policyId')
    const chassisNumber = selector(state, 'chassisNumber')
    return {
        vehicleRegistrationNumber,
        vinCode,
        policyId,
        chassisNumber,
        SearchPolicyFormFields: getFormValues('SearchPolicyForm')(state),
        openSearchModal: state.policies.openSearchModal,
        translate: getTranslate(state.locale),
        currentLocale: getActiveLanguage(state.locale),
    }
};
PolicySearchModal = withRouter(PolicySearchModal);

export default connect(mapStateToProps)(PolicySearchModal)


// WEBPACK FOOTER //
// ./src/components/PolicySearchModal/PolicySearchModal.js